import React from "react";

function EndScreen() {
  return (
    <div>
      <br />
      You're done for today!
    </div>
  );
}

export default EndScreen;
